import React from 'react';
import MyForm  from './MyForm';

const Contact = () => {
    return (
        <section className='contact-container'>
            <div className='contact-form'>
                <h1>
                Feel free to reach out to me using the following form 
                </h1>
                <MyForm />
            </div>
        </section>
    )
}

export default Contact;
